import { RedirectionTypesEnum } from 'common/enums/ButtonActionEnum'
import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import { createButtonNew } from 'client/components/core/Sidebar/components/Settings/entities/button-settings/utils/create-button'
import { createPopup } from 'client/components/core/Sidebar/components/Settings/entities/popup-settings/utils/create-popup'
import { createField } from 'client/components/entities/field-new/field-new'
import i18n from 'client/i18n'
import { createWebinarRegistrationDate } from 'client/pages/webinar-registration-page/entities/WebinarRegistrationDate'
import { createContainerStructure } from 'client/utils/createStructureUtils'

export const createPopupWebinarRegistrationFromLibrary = (locale: string) => {
  const fixedT = i18n.getFixedT(locale)

  const popupEntity = createPopup()

  const { structure, descendantEntity } = createContainerStructure(
    popupEntity,
    locale,
    0,
  )

  const input = createField(
    descendantEntity.id,
    descendantEntity.masterBlockId,
    {
      slug: FieldSlugEnum.Email,
      placeholder: 'Email',
    },
  )

  const webinarRegistrationDate = createWebinarRegistrationDate(
    descendantEntity.id,
    descendantEntity.masterBlockId,
  )
  webinarRegistrationDate.margin.marginTop = 15
  webinarRegistrationDate.mobileMargin.marginTop = 5

  const button = createButtonNew(
    descendantEntity.id,
    fixedT('entities.button.default_text'),
    fixedT('entities.button.default_sub_text'),
    descendantEntity.masterBlockId,
  )
  button.background = 'rgba(74, 144, 226, 1)'
  button.border = {
    ...button.border,
    radius: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
  }
  button.textColor = 'rgba(255, 255, 255, 1)'
  button.textFontFamily = 'Raleway'
  button.textFontSize = 24
  button.lineHeight = 24
  button.margin = {
    marginTop: 15,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
  }
  button.width = '100%'
  button.redirectionType = RedirectionTypesEnum.nextStep
  button.padding = {
    paddingTop: 6,
    paddingRight: 100,
    paddingBottom: 7,
    paddingLeft: 100,
  }

  return {
    ascendantId: popupEntity.id,
    structure: {
      ...structure,
      [descendantEntity.id]: {
        ...descendantEntity,
        childIds: [input.id, webinarRegistrationDate.id, button.id],
      },
      [popupEntity.id]: {
        ...popupEntity,
        childIds: [structure[descendantEntity.parentId as string].id],
      },
      [input.id]: input,
      [webinarRegistrationDate.id]: webinarRegistrationDate,
      [button.id]: button,
    },
  }
}
